define('shared/util/modeDetector',[
    '$', 
    'shared/lib/Emitter', 
    'shared/lib/RSVP', 
    'shared/util/throttle', 
    'shared/util/hub'
], function($, Emitter, RSVP, throttle, hub) {
    'use strict';

    var CHN = '/design/modeDetector';
    var $win = $(window);
    var modeMap;
    var emitter = new Emitter();
    var dfdReady = new RSVP.defer();
    var sharedMode;

    function setMode() {
        var mode;
        var modeConfig;

        for(var key in modeMap) {
            if (!modeMap.hasOwnProperty(key)) {
                continue;
            }

            modeConfig = modeMap[key];

            if (
                window.innerWidth > modeConfig.s &&
                window.innerWidth < modeConfig.e
            ) {
                mode = key;
                break;
            }
        }
        
        sharedMode = mode;
        emitter.reemit('change', mode);
    }

    hub.get(CHN)
    .then(function(mm){
        modeMap = mm;
        setMode();
        $win.on('resize', throttle(setMode));
        dfdReady.resolve();
        hub.on('changed', function(chn, value){
            if (chn !== CHN) {
                return;
            }
            modeMap = value;
            setMode();
        });
    });

    emitter.mode = function() {
        return dfdReady.promise
            .then(function(){
                return sharedMode;
            });
    };

    setTimeout(function(){
        if (hub.peek(CHN) != null) {
            return;
        }
        hub.set(CHN, {
            'mobile': {s: Number.NEGATIVE_INFINITY, e: 0},
            'desktop': {s: 1, e: Number.POSITIVE_INFINITY}
        });
    }, 1000);

    return emitter;
});
